import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/layouts/default.vue").then(m => m.default || m))
}